export enum BarterTabEnum {
    BasicInfo = 1,
    CounterpartyParcels = 2,
    MyParcels = 3,
    ReceivedParcels = 4,
    PassedParcels = 5,
    Map = 6,
    Payments = 7,
}